<!-- START: forms/internal assets -->
<section class="card" *ngIf="criteriaList && question">
    <div class="card-header">
        <span class="cat__core__title">
            <strong>Evaluation Answer and Submission</strong>
        </span>
    </div>
    <div class="card-block watermark">
        <div class="row">
            <div class="col-lg-2" style="border-right: 1px solid lightgray;">
                <!-- sidebar according start here -->
                <app-risk-category-sidebar [criteriaList]="criteriaList"
                    (changeCriteriaDetails)="changeCriteriaList($event)" [deptName]="deptName"
                    [answerDetails]="answerDetails" [question]="question"
                    (selectedIndex)="selectQuestionForSideBar($event)" [assesseeListToExecute]="assesseeListToExecute"
                    (selectedCriteria)="selectedCriteria($event)"
                    [activeCriteria]="activeCriteria"></app-risk-category-sidebar>
                <!-- sidebar according end here -->

            </div>
            <div class="col-lg-10">
                <div class="form-group row">
                    <div class="col-md-12">
                        <div class="col-md-12" style="border: 1px solid #e4e9f0;padding: 10px;">
                            <span class=" col-md-3">
                                <span class="cat__core__donut cat__core__donut--success"></span>
                                Answered
                            </span>
                            <span class=" col-md-3">
                                <span class="cat__core__donut cat__core__donut--info"></span>
                                Pending
                            </span>
                            <span class=" col-md-3">
                                <span class="cat__core__donut cat__core__donut--danger"></span>
                                Unanswered
                            </span>
                        </div>
                    </div>
                </div>

                <div class="mb-5">
                    <app-risk-view-overall-questions [criteriaList]="criteriaList" [scoreRange]="scoreRange"
                        [deptName]="deptName" [formAnonymous]="formAnonymous"
                        [isNextButtonEnabled]="isNextButtonEnabled" [assesseeListToExecute]="assesseeListToExecute"
                        [scoreParticularDetails]="scoreParticularDetails" (changedStatus)="submitAnswerById($event)"
                        (commentChangeStatus)="submitComment($event)" [criteriaName]="criteriaName"
                        [question]="question"></app-risk-view-overall-questions>
                </div>

            </div>
        </div>
    </div>
</section>